import React from "react";
import { graphql } from "gatsby";
import StructuredText from "../custom-structured-text-renderer";
import parse from "html-react-parser";
import { Asset } from "../../../../plugins/gatsby-plugin-atollon";
import { RightArrow } from "../../icons";
import AnimationButton from "./animation-button";

const TitleContentImageButton = ({title, richContent, image, video, button}) => {
  return (
    <section className="tcib">
      <div className="tcib__inner">
        {title && <h2 data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">{parse(title)}</h2>}
        <div className="tcib__wrapper">
          <div className="tcib__content" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
            {richContent && <StructuredText data={richContent}/>}
            {button.length > 0 &&
              <AnimationButton
                className='btn btn--animation'
                to={button[0].link[0].externalLink ? button[0].link[0].externalLink : button[0].link[0].internalLink?.permalink}>
                {button[0].title}
                <RightArrow color="#ffffff"/>
              </AnimationButton>
            }
          </div>

          <div className="tcib__image" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
            {image && <Asset asset={image}/>}
            {video && <video className="tcib__video" autoPlay loop muted playsInline src={video}/>}
          </div>
        </div>
      </div>
    </section>
  )
}

export default TitleContentImageButton

export const query = graphql`
fragment TitleContentImageButtonProps on DatoCmsTitleContentImageButton {
  ... on DatoCmsTitleContentImageButton {
    id
    video
    title
    richContent {
      value
    }
    image {
        ...InternalAssetProps
    }
    button {
      ...LinkWithTitleProps
    }
  }
}
`